<template>
    <article v-if="!pending">
        <ContentHero
            :background-color="contentHero?.backgroundColor"
            :image-position="contentHero?.imagePosition"
            :image="contentHero?.image?.[0]"
        >
            <template #title>{{ entry?.title }}</template>
            <template #description>{{ contentHero?.description }}</template>
            <template #caption>{{ contentHero?.caption }}</template>
        </ContentHero>

        <VizyBlocksContentBuilder
            :pending="pending"
            :nodes="entry?.contentBuilder?.nodes"
        />

        <ContactBlock
            v-if="(entry?.showContactForm && entry?.contactForm?.[0]) || pending"
            :pending="pending"
            :background-color="entry?.contactForm?.[0]?.backgroundColor"
        >
            <template
                v-if="entry?.contactForm?.[0]?.title"
                #title
            >
                {{ entry.contactForm[0].title }}
            </template>

            <template
                v-if="entry?.contactForm?.[0]?.description"
                #description
            >
                {{ entry.contactForm[0].description }}
            </template>
        </ContactBlock>

        <NewsletterBlock
            v-if="data?.entry?.newsletterBlock?.[0] || pending"
            :image="data?.entry?.newsletterBlock?.[0].image?.[0]"
            :pending="pending"
            :background-color="data?.entry?.newsletterBlock?.[0]?.backgroundColor"
            :list-id="data?.entry?.newsletterBlock?.[0]?.listId ?? undefined"
            :consent-id="data?.entry?.newsletterBlock?.[0]?.consentId ?? undefined"
        >
            <template
                v-if="data?.entry?.newsletterBlock?.[0]?.title"
                #title
            >
                {{ data.entry.newsletterBlock[0].title }}
            </template>

            <template
                v-if="data?.entry?.newsletterBlock?.[0]?.description"
                #description
            >
                {{ data.entry.newsletterBlock[0].description }}
            </template>
        </NewsletterBlock>
    </article>
</template>

<script setup>
import StoryQuery from '~/graphql/queries/story.graphql';

const { variables } = useCraftGraphql();
const response = await useLazyAsyncQuery({
    query: StoryQuery,
    variables
});
const pending = response.pending;
const data = response.data;

const contentHero = toValue(response?.data)?.entry?.contentHero?.[0];
const { craftEntry: entry } = useCraftPage(response);
</script>
